import { render, staticRenderFns } from "./SelectionCard.vue?vue&type=template&id=ef27a538&scoped=true&"
import script from "./SelectionCard.vue?vue&type=script&lang=js&"
export * from "./SelectionCard.vue?vue&type=script&lang=js&"
import style0 from "./SelectionCard.vue?vue&type=style&index=0&id=ef27a538&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef27a538",
  null
  
)

export default component.exports